module.exports = __webpack_public_path__ + "img/c2.7f548e82.png";